module.exports = __webpack_public_path__ + "img/cerrado.4f161f3f.png";